import { fetchReminders } from "@/services/api/apiServiceReminders";
import { formatReminders } from "@/services/helpers";

export default {
  namespaced: true,
  state: {
    reminders: [],
    selectedDate: null,
    selectedReminder: null,
  },
  mutations: {
    setReminders(state, reminders) {
      state.reminders = reminders;
    },
    addReminder(state, reminder) {
      state.reminders.push(reminder);
    },
    dateSelected(state, date) {
      state.selectedDate = date;
    },
    resetDate(state) {
      state.selectedDate = null;
    },
    selectReminder(state, reminder) {
      state.selectedReminder = reminder;
    },
    deleteReminder(state, id) {
      state.reminders = state.reminders.filter(
        (reminder) => reminder.id !== +id
      );
    },
    updateReminder(state, updateReminder) {
      const formattedReminder = formatReminders([updateReminder])[0];
      state.reminders = state.reminders.map((r) =>
        r.id == updateReminder.id ? formattedReminder : r
      );
    },
  },
  actions: {
    async fetchReminders({ commit }) {
      const response = await fetchReminders();
      commit("setReminders", response);
    },
    addReminder({ commit }, reminder) {
      commit("addReminder", reminder);
    },
  },
  getters: {
    reminders: (state) => state.reminders,
    selectedReminder: (state) => state.selectedReminder,
  },
};
